var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"arrow-link",attrs:{"href":_vm.href}},[_c('div',{staticClass:"label",class:{'light' : _vm.light}},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }